import React from "react";
import tomo_card from "../../../assets/tomo_card_dashboard.png";
import logo from "../../../assets/tomo_logo_black.svg";
import Grats from "../../../assets/Grats";

const SuccessModal = ({ close }) => {
  const navigateHome = () => {
    window.onbeforeunload = null;
    return window.location = "https://www.tomocredit.com/dashboard";
  };
  return (
    <div
      style={{ backgroundColor: "#FAFAFA", width: "450px" }}
      className="py-10 px-12 flex justify-center mx-auto flex-col fadeIn"
    >
      <img src={logo} alt="TomoCredit Logo" style={{ maxHeight: 36 }} />
      <h2 class="text-center font-bold text-3xl py-3">Congratulations!</h2>
      <Grats className="m-auto py-4" />
      <h2 class="font-bold text-2xl text-center py-4 mt-1">You're approved!</h2>
      <p className="text-center pt-2 pb-10 px-4">
        Please check your email for <br /> card shipment details.
      </p>
      <p className="text-center pb-5">
        <button
          className="btn btn-green px-5 py-3 text-white"
          onClick={navigateHome}
        >
          Enter Dashboard
        </button>
      </p>
    </div>
  );
};

export default SuccessModal;
